<template>
    <div class="parent-div">
        <NavBarDark></NavBarDark>
        <div class="content-start">
            <div class="container-fluid" id="main-container">
                <div class="row" id="challenge-content">
                    <div class="card col-sm-7 mx-auto text-left" id="challenge-content-text">
                        <h5>Hi 👋 </h5><br>
                        <div class="details">Please fill out your requirements. We look forward to working with you. 
                        </div><br>
                        <form class="requirement-details" action="https://formcarry.com/s/FVazlJ3zVRc" method="POST" accept-charset="UTF-8">
                            <div class="form-heading">Company Name</div>
							<input type="text" class="form-control" name="companyName" id="company-name-text"><br>

							<div class="form-heading">Email</div>
							<input type="text" class="form-control" name="companyEmail" id="company-email-text"><br>

							<div class="form-heading">Phone Number</div>
							<input type="text" class="form-control" name="companyNumber" id="company-number-text"><br>

							<div class="form-heading">Requirements</div>
							<div class="input-group mb-3" id="categories">
								<select class="custom-select" id="category-dropdown-menu" name="companyRequirement">
									<option selected>Choose the requirement</option>
									<option>Design Hiring</option>
								    <option>Design work required (UI, UX, Graphic Design)</option>
								    <option>Something else</option>
								</select>

							</div><br><br>


							<div class="form-heading" id="more-details">
		  						<label for="editor">More details about your requirement</label><br>
		  						<textarea class="form-control" name="companyRequirementDetail" id="editor" rows="4" style="width:100%"></textarea>
							</div><br><br>


							<div class="text-center">
								<input type="submit" value="SUBMIT" class="btn btn-success" id="form-submission-cta">
                          		
                          	</div><br><br>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import NavBarDark from '@/components/NavBarDark.vue'
export default {
    name: 'CompanyContact',
    components: {
        NavBarDark
    }
}
</script>

<style scoped>
    .parent-div {
        background-color: #6c63ff;
    }

    .card {
		margin-top:5px; 
		margin-bottom:20px; 
		padding-top:50px;
        padding-bottom:20px;
        padding-left:50px;
        padding-right:0px;
		border:none;
		box-shadow: 2px 1px 2px 0px rgba(46,61,73,0.15);
        transition: all 0.3s ease;
		font-family: Helvetica;
	}

    #main-container {
        color:#222;
        background-color:#f8faff !important;
    }

    #challenge-content {
        margin-left:0%;
        margin-right:0%;
    }

    #challenge-content-text {
        padding-right:7%;
    }

    .form-heading {
        font-size: 0.9rem;
        color: #222;
    }

    .requirement-details {
        font-size: 0.9rem;
    }

    #form-submission-cta {
        background-color: #f25792;
        color: white;
        border-color: #f25792;
        padding-left: 2.8%;
        padding-right: 2.8%;
        padding-top: 1.9%;
        padding-bottom: 1.9%;
        width: 35%;
        font-size: 0.8rem;
        border-radius: 7px;
        cursor: pointer;
    }

</style>

